module.exports = __webpack_public_path__ + "img/uefa-nations-league-1864.9b9f25c4.png";